/**
 * Facilities del usuario guardadas en login (mismo origen que dashboard / DropdownFacility).
 * Prioridad: setFacilityOptions → userData.facilities
 */
export function getFacilityOptionsFromStorage() {
  try {
    const encoded = localStorage.getItem('setFacilityOptions')
    if (encoded) {
      const decoded = atob(encoded)
      if (decoded && decoded.trim()) {
        const list = JSON.parse(decoded)
        if (Array.isArray(list) && list.length) return list
      }
    }
  } catch {
    // continuar con userData
  }

  try {
    const raw = localStorage.getItem('userData')
    if (!raw) return []
    const user = JSON.parse(raw)
    const facilities = user && Array.isArray(user.facilities) ? user.facilities : []
    return facilities.filter(f => {
      if (!f || f.id == null) return false
      if (f.status === false) return false
      if (f.pivot && f.pivot.status === false) return false
      return true
    })
  } catch {
    return []
  }
}
